import {Draft} from '@reduxjs/toolkit'
import {createActionCreators, ImmerReducer} from 'immer-reducer'
import {v4 as uuidV4} from 'uuid'
import _capitalize from 'lodash.capitalize'
import {ToastStateType, ToastType} from './state'
import {ToastVariant} from 'src/components/Toast/index'

class Toast extends ImmerReducer<ToastStateType> {
  toastAdded(toastToAdd: ToastType) {
    const items = [toastToAdd] as Draft<ToastType[]>
    this.draftState.toasts.push(...items)
  }
  toastRemoved(toastToRemove: ToastType) {
    this.draftState.toasts = this.draftState.toasts.filter(toast => toast.id !== toastToRemove.id)
  }
  toastLastRemoved() {
    if (this.draftState.toasts.length > 0) {
      this.draftState.toasts = [
        ...this.draftState.toasts.slice(0, this.draftState.toasts.length - 1),
      ]
    }
  }
}

export const genericRequestSuccess = () => function(dispatch) {
  const toast: ToastType = {
    id: uuidV4(),
    variant: 'success',
    header: 'Success',
    message: 'Your request has been successfully completed.',
  }

  dispatch(toastAC.toastAdded(toast))
}

export const genericRequestError = () => function(dispatch) {
  const toast: ToastType = {
    id: uuidV4(),
    variant: 'critical',
    header: 'Error',
    message: 'There was an issue with processing your request.',
  }

  dispatch(toastAC.toastAdded(toast))
}

export const customMessageRequest = (variant: ToastVariant, message: string, delay?: number) => function(dispatch) {
  const toast: ToastType = {
    id: uuidV4(),
    variant: variant,
    header: _capitalize(variant),
    message: message,
    delay: delay,
  }

  dispatch(toastAC.toastAdded(toast))
}

export const toastAC = createActionCreators(Toast)

export default Toast
